enum NewsletterStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description subscription for newsletter
   */
  Subscription = "/v2/newsletter-subscription",
}
// /v2/newsletter-subscription
export const NewsletterEndpoints = {
  ...NewsletterStatic,
};

export type NewsletterEndpoint = typeof NewsletterEndpoints;
